export default __webpack_public_path__ + "static/media/AcceleronsGallery_37.71bf7ab3.JPG";